(function () {
  'use strict';

  /* ── CSS height sync ──────────────────────────────────────── */
  function syncHeight() {
    var root = document.documentElement;
    var ann  = document.querySelector('.sbc-ann');
    root.style.setProperty(
      '--sbc-announcement-height',
      ann instanceof HTMLElement ? ann.offsetHeight + 'px' : '0px'
    );
  }

  /* ── Announcement rotation ────────────────────────────────── */
  function initAnnouncement() {
    var track = document.querySelector('.sbc-ann__track');
    if (!track) return;
    var slides = track.querySelectorAll('.sbc-ann__slide');
    if (!slides || slides.length < 2) return;

    var current = 0;
    var speed = parseInt(track.getAttribute('data-speed') || '4000', 10);

    function rotate() {
      var outgoing = current;
      current = (current + 1) % slides.length;
      var outEl = slides[outgoing];
      var inEl  = slides[current];
      if (!outEl || !inEl) return;
      outEl.classList.remove('sbc-ann__slide--active');
      outEl.classList.add('sbc-ann__slide--exit');
      setTimeout(function () {
        outEl.classList.remove('sbc-ann__slide--exit');
      }, 280);
      inEl.classList.add('sbc-ann__slide--active');
    }

    setInterval(rotate, speed);
  }
  /* ── Mega menu positioning ────────────────────────────────── */
  /*
   * Centers each dropdown panel under its nav item.
   * The .menu-list__submenu container is full-width (Horizon default).
   * Inside it, .mega-menu is width:max-content, so we shift it via
   * margin-left to center under whichever nav item opened it.
   * Clamped to 32px from each viewport edge.
   */
  function initMegaMenuPositioning() {
    var MARGIN = 32;

    /* Panels wider than this threshold are treated as multi-column menus
       and centered under the full header rather than the specific nav item. */
    var MULTI_COL_THRESHOLD = 480;

    function positionPanel(item) {
      var panel = item.querySelector('.mega-menu');
      if (!panel) return;

      /* The Books mega menu is centered purely in CSS (flex on its full-width
         submenu) — leave it alone so JS margins never fight the CSS. */
      if (panel.classList.contains('sbc-books-mega')) return;

      /* Measure the panel in its current state (do NOT reset the margin first —
         resetting causes a visible reset→re-set jump if anything transitions). */
      var panelRect  = panel.getBoundingClientRect();
      var panelW     = panelRect.width;
      if (!panelW) return; // panel not laid out yet — avoid a wrong offset
      var vpWidth    = window.innerWidth;
      var idealLeft;

      if (panelW > MULTI_COL_THRESHOLD) {
        /* Multi-column: center under the full header/nav area */
        idealLeft = (vpWidth - panelW) / 2;
      } else {
        /* Single/compact: center directly under the parent nav item */
        var itemRect = item.getBoundingClientRect();
        idealLeft = itemRect.left + itemRect.width / 2 - panelW / 2;
      }

      var clampedLeft = Math.max(MARGIN, Math.min(idealLeft, vpWidth - panelW - MARGIN));
      var currentM    = parseFloat(panel.style.marginLeft) || 0;
      /* Absolute margin needed to land the panel's left edge at clampedLeft. */
      var newM        = Math.round(clampedLeft - panelRect.left + currentM);

      /* Only write when it truly changes, so re-runs (pre-position, hover,
         resize) are no-ops and never nudge the panel. */
      if (newM !== Math.round(currentM)) {
        panel.style.marginLeft = newM + 'px';
      }
    }

    var items = document.querySelectorAll(
      '#header-component .menu-list__list-item:has(.menu-list__submenu)'
    );

    function positionAll() {
      items.forEach(function (item) { positionPanel(item); });
    }

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () { positionPanel(item); });
    });

    /* Position on init and again as layout/fonts settle. positionPanel is
       idempotent, so these re-runs never nudge an already-correct panel — they
       just make sure the margin is accurate BEFORE the first hover (and cover
       reload-with-cursor-already-over-a-trigger, where no mouseenter fires). */
    positionAll();
    requestAnimationFrame(positionAll);
    setTimeout(positionAll, 250);
    window.addEventListener('load', positionAll);
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(positionAll); }
    window.addEventListener('resize', positionAll);
  }

  /* ── Inline header search ─────────────────────────────────── */
  function initHeaderSearch() {
    /* Search wrap is server-rendered in the header — just attach behaviour */
    var wrap = document.getElementById('sbc-search-wrap');
    if (!wrap) return;

    /* Results panel — fixed positioned (desktop) */
    if (!document.getElementById('sbc-search-results')) {
      var resultsPanel = document.createElement('div');
      resultsPanel.id = 'sbc-search-results';
      resultsPanel.setAttribute('role', 'listbox');
      resultsPanel.setAttribute('aria-label', 'Search results');
      resultsPanel.innerHTML = '<div id="sbc-results-inner"></div>';
      document.body.appendChild(resultsPanel);
    }

    /* Modal overlay + full-screen search (mobile) */
    if (!document.getElementById('sbc-modal-overlay')) {
      var modalOverlay = document.createElement('div');
      modalOverlay.id = 'sbc-modal-overlay';
      document.body.appendChild(modalOverlay);
    }

    if (!document.getElementById('sbc-search-modal')) {
      var modal = document.createElement('div');
      modal.id = 'sbc-search-modal';
      modal.innerHTML =
        '<div id="sbc-modal-header">' +
          '<input id="sbc-modal-input" type="search" placeholder="Search books, authors…" ' +
            'autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false">' +
          '<button type="button" id="sbc-modal-close" aria-label="Close">' +
            '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
              '<path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
            '</svg>' +
          '</button>' +
        '</div>' +
        '<div id="sbc-modal-results"></div>';
      document.body.appendChild(modal);
    }

    var trigger  = document.getElementById('sbc-search-trigger');
    var input    = document.getElementById('sbc-search-input');
    var closeBtn = document.getElementById('sbc-search-close');
    var modalInput = document.getElementById('sbc-modal-input');
    var modalClose = document.getElementById('sbc-modal-close');
    var modalResults = document.getElementById('sbc-modal-results');
    var isOpen   = false;
    var isMobile = window.innerWidth <= 480;

    function animateNavPush() {
      var navLinks = document.querySelectorAll('#header-component .header__row--top .menu-list__link');
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReduced || navLinks.length === 0) return;

      navLinks.forEach(function(link, index) {
        link.style.animation = 'none';
        setTimeout(function() {
          var staggerDelay = index * 50; // 50ms per item, left-to-right
          link.style.animation = 'sbc-nav-push 620ms cubic-bezier(0.43, 0.13, 0.23, 0.96) forwards ' + staggerDelay + 'ms';
        }, 10);
      });
    }

    function open() {
      isOpen = true;
      trigger.setAttribute('aria-expanded', 'true');
      trigger.classList.add('sbc-open');
      if (isMobile) {
        modal.classList.add('sbc-show');
        modalOverlay.classList.add('sbc-show');
        setTimeout(function() { modalInput.focus(); }, 150);
      } else {
        wrap.classList.add('sbc-active');
        animateNavPush();
        setTimeout(function() { input.focus(); }, 50);
      }
    }

    function close() {
      isOpen = false;
      trigger.setAttribute('aria-expanded', 'false');
      if (isMobile) {
        modal.classList.remove('sbc-show');
        modalOverlay.classList.remove('sbc-show');
        modalInput.value = '';
        modalResults.innerHTML = '';
      } else {
        wrap.classList.remove('sbc-active');
        trigger.classList.remove('sbc-open');
        input.value = '';
        resultsPanel.classList.remove('sbc-show');
        // Clear nav animations for smooth reversion
        var navLinks = document.querySelectorAll('#header-component .header__row--top .menu-list__link');
        navLinks.forEach(function(link) { link.style.animation = 'none'; });
      }
    }

    var resultsInner = document.getElementById('sbc-results-inner');
    var searchTimeout;

    function positionResults() {
      var rect = input.getBoundingClientRect();
      var panelWidth = Math.max(200, rect.right - rect.left);
      resultsPanel.style.top = (rect.bottom + 8) + 'px';
      resultsPanel.style.left = rect.left + 'px';
      resultsPanel.style.width = panelWidth + 'px';
    }

    function showResults() {
      if (isMobile) {
        modalResults.style.display = 'block';
      } else {
        resultsPanel.classList.add('sbc-show');
        positionResults();
      }
    }

    function hideResults() {
      if (isMobile) {
        modalResults.style.display = 'none';
      } else {
        resultsPanel.classList.remove('sbc-show');
      }
    }

    function fetchResults(query) {
      if (!query.trim()) {
        hideResults();
        return;
      }
      var url = '/search/suggest.json?q=' + encodeURIComponent(query);
      fetch(url)
        .then(function(r) { return r.json(); })
        .then(function(data) { renderResults(query, data); })
        .catch(function() { hideResults(); });
    }

    function buildUrl(path) {
      var url = path || '';
      var params = new URLSearchParams(window.location.search);
      var previewId = params.get('preview_theme_id');
      if (previewId && !url.includes('preview_theme_id')) {
        url += (url.includes('?') ? '&' : '?') + 'preview_theme_id=' + previewId;
      }
      return url;
    }

    function formatPrice(price) {
      if (!price) return '';
      var num = parseFloat(price);
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR';
      if (currency === 'USD') return '$' + num.toFixed(2);
      if (currency === 'GBP') return '£' + num.toFixed(2);
      if (currency === 'EUR') return '€' + num.toFixed(2);
      return '₹' + num.toLocaleString('en-IN', { maximumFractionDigits: 0 });
    }

    function renderResults(query, data) {
      var html = '';
      var hasResults = false;

      var results = (data.resources && data.resources.results) || {};
      var products = results.products || [];
      var collections = results.collections || [];
      var queries = results.queries || [];

      // Display products (limited to 4)
      var productsToShow = products.slice(0, 4);
      if (productsToShow.length > 0) {
        html += '<div class="sbc-section-label">' + (productsToShow.length === 1 ? 'Discover Book' : 'Discover Books') + '</div>';
        productsToShow.forEach(function(p) {
          var thumb = (p.featured_image && p.featured_image.url) || p.image || '';
          var price = formatPrice(p.price);
          html += '<a href="' + buildUrl(p.url) + '" class="sbc-result-row">' +
            (thumb ? '<div class="sbc-result-thumb" style="background-image:url(' + thumb + ')"></div>' : '<div class="sbc-result-thumb"></div>') +
            '<div class="sbc-result-text">' +
            '<div class="sbc-result-title">' + (p.title || '') + '</div>' +
            (p.vendor ? '<div class="sbc-result-byline">' + p.vendor + '</div>' : '') +
            (price ? '<div class="sbc-result-price">' + price + '</div>' : '') +
            '</div></a>';
          hasResults = true;
        });

        // Add "View all results" footer if there are more products.
        // No count — the suggest.json total differs from the full /search page
        // total, so a number here reads as a mismatch. Link goes to full search.
        if (products.length > 4) {
          html += '<a href="' + buildUrl('/search?q=' + encodeURIComponent(query)) + '" class="sbc-section-footer">' +
            'View all results' +
            '</a>';
        }
      }

      if (collections.length > 0) {
        if (html) html += '<div class="sbc-divider"></div>';
        html += '<div class="sbc-section-label">Collections</div>';
        collections.forEach(function(c) {
          // Hide the internal "[SERIES] " admin prefix from the storefront name.
          var cTitle = (c.title || '').replace(/^\s*\[SERIES\]\s*/i, '');
          html += '<a href="' + buildUrl(c.url) + '" class="sbc-result-row">' +
            '<div class="sbc-result-text" style="width:100%">' +
            '<div class="sbc-result-cat">Collection</div>' +
            '<div class="sbc-result-title">' + cTitle + '</div>' +
            '</div></a>';
          hasResults = true;
        });
      }

      if (queries.length > 0) {
        if (html) html += '<div class="sbc-divider"></div>';
        html += '<div class="sbc-section-label">Explore More</div>';
        html += '<div class="sbc-suggestions-wrap">';
        queries.forEach(function(q) {
          var qt = q.text || '';
          // Real search links (were inert <div>s). href is URL-encoded; same
          // /search?q= destination as Enter / "View all results". buildUrl
          // preserves preview_theme_id.
          html += '<a href="' + buildUrl('/search?q=' + encodeURIComponent(qt)) + '" class="sbc-result-query">' + qt + '</a>';
          hasResults = true;
        });
        html += '</div>';
      }

      if (!hasResults) {
        html = '<div class="sbc-results-empty">' +
          '<div class="sbc-results-empty-icon">🔍</div>' +
          '<div class="sbc-results-empty-title">Let\'s discover something new</div>' +
          '<p class="sbc-results-empty-text">No results found. Try different keywords or explore by:</p>' +
          '<div class="sbc-results-empty-actions">' +
          '<a href="' + buildUrl('/collections/all') + '" class="sbc-results-empty-btn sbc-results-empty-btn-primary">Browse All Products</a>' +
          '<a href="' + buildUrl('/collections/books') + '" class="sbc-results-empty-btn sbc-results-empty-btn-secondary">Browse Books</a>' +
          '</div>' +
          '</div>';
      }

      if (isMobile) {
        modalResults.innerHTML = html;
      } else {
        resultsInner.innerHTML = html;
      }
      showResults();
    }

    function handleInput(query) {
      clearTimeout(searchTimeout);
      var q = query.trim();
      if (!q) { hideResults(); return; }
      searchTimeout = setTimeout(function() { fetchResults(q); }, 200);
    }

    input.addEventListener('input', function() {
      handleInput(input.value);
    });

    modalInput.addEventListener('input', function() {
      handleInput(modalInput.value);
    });

    // Enter submits to the full search results page. These inputs are bare
    // (not inside a <form>) so nothing submitted them before — Enter did
    // nothing. buildUrl preserves preview_theme_id; same destination as the
    // "View all results" footer. Predictive fetch on 'input' is untouched.
    function submitSearch(value) {
      var q = (value || '').trim();
      if (!q) return;
      window.location.href = buildUrl('/search?q=' + encodeURIComponent(q));
    }

    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') { e.preventDefault(); submitSearch(input.value); }
    });

    modalInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') { e.preventDefault(); submitSearch(modalInput.value); }
    });

    trigger.addEventListener('click', function(e) {
      e.stopPropagation();
      if (isOpen) close(); else open();
    });

    closeBtn.addEventListener('click', function() { close(); trigger.focus(); });
    modalClose.addEventListener('click', function() { close(); trigger.focus(); });
    modalOverlay.addEventListener('click', function() { close(); trigger.focus(); });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && isOpen) { close(); trigger.focus(); }
    });

    document.addEventListener('click', function(e) {
      if (isOpen && !isMobile && !wrap.contains(e.target) && !resultsPanel.contains(e.target)) close();
    });

    window.addEventListener('scroll', function() {
      if (isOpen && resultsPanel.classList.contains('sbc-show')) positionResults();
    }, true);

    window.addEventListener('resize', function() {
      isMobile = window.innerWidth <= 480;
      if (isOpen && !isMobile && resultsPanel.classList.contains('sbc-show')) positionResults();
    });
  }

  /* ── Header responsive state restoration ──────────────────── */
  var lastBreakpoint = window.innerWidth >= 750 ? 'desktop' : 'mobile';
  var lastWindowWidth = window.innerWidth;

  function handleHeaderResize() {
    var currentWidth = window.innerWidth;
    var currentBreakpoint = currentWidth >= 750 ? 'desktop' : 'mobile';

    if (currentBreakpoint !== lastBreakpoint || Math.abs(currentWidth - lastWindowWidth) > 50) {
      lastBreakpoint = currentBreakpoint;
      lastWindowWidth = currentWidth;

      document.body.style.width = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.overflow = '';

      var allDialogs = document.querySelectorAll('dialog[open]');
      allDialogs.forEach(function(dialog) {
        if (dialog.close) dialog.close();
      });

      var drawer = document.querySelector('header-drawer');
      if (drawer) {
        drawer.removeAttribute('open');
        drawer.removeAttribute('aria-expanded');
        var drawerDialog = drawer.querySelector('dialog');
        if (drawerDialog) {
          drawerDialog.removeAttribute('open');
          if (drawerDialog.close) drawerDialog.close();
        }
      }

      var searchModal = document.getElementById('sbc-search-modal');
      if (searchModal) {
        searchModal.classList.remove('sbc-show');
        searchModal.style.display = '';
      }
      var modalOverlay = document.getElementById('sbc-modal-overlay');
      if (modalOverlay) {
        modalOverlay.classList.remove('sbc-show');
        modalOverlay.style.display = '';
      }

      var searchWrap = document.getElementById('sbc-search-wrap');
      if (searchWrap) searchWrap.classList.remove('sbc-active');
      var searchTrigger = document.getElementById('sbc-search-trigger');
      if (searchTrigger) {
        searchTrigger.classList.remove('sbc-open');
        searchTrigger.setAttribute('aria-expanded', 'false');
      }

      var headerComponent = document.getElementById('header-component');
      if (headerComponent) {
        headerComponent.style.display = '';

        // Dispatch event to trigger menu recalculation
        var minimumReached = currentBreakpoint === 'mobile';
        var overflowEvent = new CustomEvent('overflow-minimum-reached', {
          detail: { minimumReached: minimumReached },
          bubbles: true
        });
        headerComponent.dispatchEvent(overflowEvent);
      }
    }
  }

  /* ── Keep cart drawer open + no flash when last item is removed ──
   * Two coupled bugs when removing the final cart line:
   *
   * 1. Drawer snaps shut. The remove button fires onLineItemRemove in the
   *    click's capture phase; for the last item that calls replaceChildren(),
   *    detaching the clicked button. The drawer's bubble-phase outside-click
   *    handler then sees the now-detached target as "outside" and closes.
   *
   * 2. Cream flash. Horizon's empty-cart view transition fades the old contents
   *    out (opacity → 0) while the empty state fades in (opacity 0 → 1); during
   *    the overlap the cream drawer background shows through.
   *
   * Fix: defer the teardown to a microtask (so the click finishes propagating
   * with the button still attached → never read as "outside"), and within that
   * microtask run the original with the empty-cart view transition bypassed (no
   * fade → no flash). Bypassing the transition is what caused bug #1 in earlier
   * attempts, but only because it ran during the click; here we're already past
   * the click, so the synchronous DOM swap is safe.
   *
   * Patches the prototype once, so it is independent of how the drawer is
   * rendered, morphed, or re-instantiated. */
  function patchCartItemRemove() {
    customElements.whenDefined('cart-items-component').then(function () {
      var CIC = customElements.get('cart-items-component');
      if (!CIC || CIC.prototype.__sbcRemovePatched) return;
      if (typeof CIC.prototype.onLineItemRemove !== 'function') return;
      CIC.prototype.__sbcRemovePatched = true;

      var orig = CIC.prototype.onLineItemRemove;
      CIC.prototype.onLineItemRemove = function (line) {
        var rows = (this.refs && this.refs.cartItemRows) || [];
        var row  = rows[line - 1];
        var isLast = !!row && [row].concat(rows.filter(function (r) {
          return r.dataset.parentKey === row.dataset.key;
        })).length === rows.length;

        if (!isLast) return orig.call(this, line);

        var self = this;
        queueMicrotask(function () {
          // Bypass the empty-cart view transition for an instant, flash-free
          // swap. The original reaches document.startViewTransition synchronously
          // (the 'empty-cart-drawer' type isn't a registered async type), so a
          // save/run/restore around the call reliably catches it.
          var nativeSVT = document.startViewTransition;
          if (typeof nativeSVT === 'function') {
            document.startViewTransition = function (cb) {
              var run = typeof cb === 'function' ? cb : (cb && cb.update);
              if (typeof run === 'function') run();
              var done = Promise.resolve();
              return {
                ready: done, finished: done, updateCallbackDone: done,
                skipTransition: function () {}, types: new Set()
              };
            };
          }
          try {
            orig.call(self, line);
          } finally {
            document.startViewTransition = nativeSVT;
          }
        });
      };
    });
  }

  /* ── Preserve scroll position when cart closes on mobile ───── */
  function fixCartScrollRestore() {
    // dialog:close has bubbles:false — must listen on the element, not document.
    var cartDrawer = document.querySelector('cart-drawer-component');
    if (!cartDrawer) return;

    cartDrawer.addEventListener('dialog:close', function () {
      // history.back() fires a popstate that resets scroll to 0. Re-apply the
      // correct position after the popstate so the page stays in place.
      var correctScroll = window.scrollY || window.pageYOffset;

      window.addEventListener('popstate', function () {
        requestAnimationFrame(function () {
          window.scrollTo({ top: correctScroll, behavior: 'instant' });
        });
      }, { once: true });
    });
  }

  /* ── Mega menu: stop a click from freezing the submenu open ──
   * Each top-level item (blocks/_header-menu.liquid) binds on:focus="/activate".
   * The submenu opens on hover (pointerenter) AND on focus. A mouse click focuses
   * the item, so the submenu stays open ("frozen") until focus moves away (a click
   * elsewhere fires blur -> deactivate). Fix: on hover/mouse devices only, prevent
   * the top-level link from taking focus on mousedown. Clicking a link still
   * navigates, hover still opens the menu, and keyboard focus (Tab) is untouched —
   * so accessibility and touch behaviour are preserved. */
  function initMegaMenuClickFix() {
    var menu = document.querySelector('header-menu');
    if (!menu) return;
    // Only for true mouse/hover devices; leave touch (tap-to-open) alone.
    if (!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches)) return;
    menu.addEventListener('mousedown', function (e) {
      var link = e.target.closest('.menu-list__link');
      if (link && menu.contains(link)) {
        // Prevent focus (and thus focus-activate) without cancelling the click.
        e.preventDefault();
      }
    });
  }

  /* ── Init ─────────────────────────────────────────────────── */
  function init() {
    syncHeight();
    initAnnouncement();
    initMegaMenuPositioning();
    initMegaMenuClickFix();
    initHeaderSearch();
    patchCartItemRemove();
    fixCartScrollRestore();
  }

  // init() runs syncHeight() first, so no separate pre-init call is needed.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', syncHeight);
  window.addEventListener('resize', syncHeight);
  window.addEventListener('resize', handleHeaderResize);

  var observer = new MutationObserver(function () { syncHeight(); });
  var ann = document.querySelector('.sbc-ann');
  if (ann) {
    observer.observe(ann, {
      attributes: true,
      childList: true,
      subtree: true
    });
  }
})();
